import React, { useCallback, useState } from 'react'
import { AppSvg, ButtonVertical, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import { lang } from './lang'
import SettingsModal from './SettingsModal'

interface Props {
    isDisabled?: boolean
    card?: GetCard
}

function Settings({ card, isDisabled }: Props) {
    const [isOpen, setIsOpen] = useState(false)

    const onClose = useCallback(() => {
        setIsOpen(false)
    }, [])

    const onOpen = useCallback(() => {
        setIsOpen(true)
    }, [])

    return (
        <>
            <SettingsModal isOpen={isOpen} onClose={onClose} card={card} />
            <ButtonVertical
                dataPointer="settings"
                label={<FormattedHTMLMessage {...lang.settings} />}
                role="button"
                icon={<AppSvg svgName={newIcons.ic24Settings} path="new-icons" size={24} />}
                onClick={onOpen}
                isDisabled={isDisabled}
            />
        </>
    )
}

export default Settings
